export default __webpack_public_path__ + "20a9db2.png";